import { render } from "./AwaitingReceivable.vue?vue&type=template&id=ec9f164e"
import script from "./AwaitingReceivable.vue?vue&type=script&lang=js"
export * from "./AwaitingReceivable.vue?vue&type=script&lang=js"

import "./AwaitingReceivable.vue?vue&type=style&index=0&id=ec9f164e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__